import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/tha_chamber_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-64bfe11c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "the Banner",
  class: "banner",
  src: "/images/thaChamberPhotos/ChamberBanner4K.png"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "the logo",
  src: _imports_0
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cards" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "card",
    href: "https://instagram.com/c0rs_",
    target: "_"
  }, "c0rs"),
  /*#__PURE__*/_createElementVNode("a", {
    class: "card",
    href: "https://instagram.com/chago_51",
    target: "_"
  }, "Chago 51"),
  /*#__PURE__*/_createElementVNode("a", {
    class: "card",
    href: "https://www.instagram.com/verenatattoos/",
    target: "_"
  }, "verenatattoos")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2277.146214255628!2d8.59878577448709!3d47.255733011972374!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479aa9d7fad4561f%3A0xcd4460ef7cd0e54d!2sTHA%20CHAMBER!5e0!3m2!1sde!2sch!4v1638461521250!5m2!1sde!2sch",
  width: "100%",
  height: "100%",
  style: {"border":"0","min-height":"450px"},
  allowfullscreen: "",
  loading: "lazy"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HelloWorld = _resolveComponent("HelloWorld")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_HelloWorld),
    _hoisted_4,
    _hoisted_5
  ]))
}